import { Component, OnInit } from '@angular/core';
import * as jQuery from 'jquery';
import { DynamicItem } from 'src/app/main/dynamic/dynamic-item';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent extends DynamicItem implements OnInit {

  constructor() { super() }

  ngOnInit() {
    setTimeout(() => {
      this.attribute.attributes.forEach(element => {
        $('#m_accordion_7_' + this.getOptionByKey(element, 'identifier') + '_head').attr('href', '#m_accordion_7_' + this.getOptionByKey(element, 'identifier') + '_body');
        $('#m_accordion_7_' + this.getOptionByKey(element, 'identifier') + '_body').attr('aria-labelledby', '#m_accordion_7_' + this.getOptionByKey(element, 'identifier') + '_head');
      });
    }, 1000);
  }

  getOptionByKey(attribute: AttributeModel, key: string): string {
    if (!attribute.options) {
        return "";
    }

    let opt = attribute.options
        .find(option => option.key.toLowerCase() == key.toLowerCase());

    if (opt) {
        return opt.value;
    }
    else {
        return "";
    }
  }
}
